import React ,{useEffect, useState} from "react";
import Navbar from "../components/Navbar";
// import Product from "./Product";
import Asset from "./Asset"
import Footer from "../components/Footer";
import { useParams } from "react-router-dom";
import axios, { all } from "axios";
import Table from "./ProductTransactionTable";
var config = require("../../src/config/dev").default;

const useAllData = (props)=>{
    console.log("propinAssetPage",props);
    const [nft,setNft] = useState([]);
    const [EPRnft,setEPRNft] = useState([]);
    const params = useParams();
    console.log("params",params)
    const {tokenId, tokenAddress, assetType} = params;
    const fetchNft = async () =>{
        let nftResult;
        try {
            const res = await axios.get(config.API_ENDPOINT+'src/v1/nftdetails', {
                headers: {
                    'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                },
                params:{
                    tokenId: `${tokenId}`
                }
            });
            console.log("Res", res);
            nftResult = res.data.data.result;
        } catch(err) {
            if (err.response?.status === 401) {
                console.log("Session expired or unauthorized. Please log in again.");
            } else {
                console.log(err);
            }
            return;
        }

        if (!nftResult) return;
        await Promise.all(nftResult);
        setNft(nftResult);
        };

        const fetchEPRNft = async () =>{
            let nftResult;
            try {
                const res = await axios.get(config.API_ENDPOINT+'src/v1/eprnftdetails', {
                    headers: {
                        'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                    },
                    params:{
                        tokenId: `${tokenId}`
                    }
                });
                console.log("Res", res);
                nftResult = res.data.data.result;
            } catch(err) {
                if (err.response?.status === 401) {
                    console.log("Session expired or unauthorized. Please log in again.");
                } else {
                    console.log(err);
                }
                return;
            }

            if (!nftResult) return;
            await Promise.all(nftResult);
            setNft(nftResult);
            };

        // const fetchEPRNft = async () =>{  
        //     const EPRnftResult = await axios.get(config.API_ENDPOINT+'src/v1/eprnftdetails', {
        //             headers: {
        //             'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
        //             },
        //             params:{
        //               tokenId: `${tokenId}`
        //             }
        //         })
        //         .then((res) => {
        //             //const nftResult = res.data.data.result;
        //             //console.log("nft=>",nftResult);
        //             console.log("Res",res);
        //             return(res.data.data.result);
                    
        //             //console.log("setNft called");
        //         })
        //         .catch((err)=>{
        //             console.log(err);
        //         })
        
        //         const nftData1 = await Promise.all(EPRnftResult);
        //         setEPRNft(EPRnftResult); 
                
                
        //     };
        useEffect(()=>{
            if(assetType == "NonEprAsset"){
                fetchNft();
            }
            else{
            fetchEPRNft();
            }
        },[]);
        // return(nft,EPRnft);
         return(nft);
    
}


function AssetPage(){
    // const [nft,setNft] = useState([]);
    // const params = useParams();
    // const {tokenId, tokenAddress} = params;
    //var fetchedProduct;
        console.log("ON Asset Page");
        const allNft=useAllData();
        console.log("allNFT",allNft);
        //console.log("allNFt==",allNft);
        if(!allNft || !allNft[0]) return "loading";
    return(
        // <div>
        //     <h1>Welcome</h1>
        // </div>
        <div className="asset-page-wrapper">
            <Navbar/>
            {/* <Product
                nfts={allNft[0]}
              />  */}
              <Asset
                nfts={allNft[0]}
              />
            {/* <Table tokenId={tokenId} tokenAddress={tokenAddress}/> */}
            <Footer/>
        </div>
    )
}

export default AssetPage;

/*
name="{nft.name}" 
description="{nft.description}" 
image="{nft.image}" 
ownerName={nft[0].nft_sale[0].ownerName}
price="{nft[0].nft_sale[0].fixedPrice}"
copies="{nft[0].no_of_copies}"
*/